import { useQueryClient } from '@tanstack/react-query';
import React from 'react';

import { queryKeys } from '../../queryKeys';

/**
 * Invalidates every query family the Account-Subscriptions area reads from:
 * the account's own billing summary/invoices/charges, the org-scoped
 * platform-billing routes, the premium (D2C) subscription, and the
 * marketplace payout keys. One place to refresh after any mutation on this
 * page — do not re-spell the query-key list at a call site.
 */
export function useInvalidateAccountBilling(): () => Promise<void> {
  const queryClient = useQueryClient();

  return React.useCallback(async () => {
    await Promise.all([
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.accountBilling._def,
      }),
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.platformBilling._def,
      }),
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.premium._def,
      }),
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.marketplacePayments._def,
      }),
    ]);
  }, [queryClient]);
}
